import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

import IcDownload from "../../../../resources/svgs/ic_download.svg";

import Container from "../../../../base/components/container.js";
import List from "../../../../base/components/list.js";

import { ProjectModel } from "../../../../models/projects/project_model.js";

const desktopBulletSide = 32;
const padBulletSide = 32;
const phoneBulletSide = 24;

const desktopBulletSpacing = 20;
const padBulletSpacing = 20;
const phoneBulletSpacing = 16;


// backgroundImage: `url(${IcDownload}) no-repeat 0px -4px`,
const blockStyles = makeStyles(theme => ({
  root: {
    ['@media (max-width: 768px)']: {
      paddingLeft: "24px",
      paddingRight: "24px"
    },
  },
  list: {
    paddingLeft: `${desktopBulletSide + desktopBulletSpacing}px`,
    ['@media (max-width: 992px)']: {
      paddingLeft: `${padBulletSide + padBulletSpacing}px`,
    },
    ['@media (max-width: 768px)']: {
      paddingLeft: `${phoneBulletSide + phoneBulletSpacing}px`,
    },
    "& li": {
      marginBottom: "18px !important",
      paddingLeft: "0px !important",
      minHeight: `${desktopBulletSide}px`,
      ['@media (max-width: 992px)']: {
        marginBottom: "16px !important",
        minHeight: `${padBulletSide}px`,
      },
      ['@media (max-width: 768px)']: {
        marginBottom: "16px !important",
        minHeight: `${phoneBulletSide}px`,
      },
    },
    "& li:before": {
      backgroundImage: `url(${IcDownload})`,
      top: "0px !important",
      left: `-${desktopBulletSide + desktopBulletSpacing}px !important`,
      backgroundSize: `${desktopBulletSide}px ${desktopBulletSide}px`,
      width: `${desktopBulletSide}px`,
      height: `${desktopBulletSide}px`,
      ['@media (max-width: 992px)']: {
        left: `-${padBulletSide + padBulletSpacing}px !important`,
        backgroundSize: `${padBulletSide}px ${padBulletSide}px`,
        width: `${padBulletSide}px`,
        height: `${padBulletSide}px`,
        
      },
      ['@media (max-width: 768px)']: {
        left: `-${phoneBulletSide + phoneBulletSpacing}px !important`,
        backgroundSize: `${phoneBulletSide}px ${phoneBulletSide}px`,
        height: `${phoneBulletSide}px`,
        width: `${phoneBulletSide}px`,
      },
    }
  }
}));

const DocumentsBlock = (props) => {

  const classes = blockStyles();
  const { className, project } = props;
  const { documents = [] } = project;

  if(documents.length == 0) {
    return (null);
  }

  return (
    <Container className = { clsx(classes.root, className) } >
      <h3> { ProjectModel.fieldDisplayName("documents") }</h3>
      <List className = { classes.list } >
        {
          documents.map(document => {
            const { name, pdf } = document;
            if(!pdf) {
              return <React.Fragment key = { document.id }/>
            }
            const { filename, url } = pdf;
            return <li key = { document.id } >
              <a className = { classes.link } 
                 target = { "_blank" }
                 href = { url } >
                { name ? name : filename }
              </a>
            </li>
          })
        }
      </List>
    </Container>
  );
  
}

export default DocumentsBlock;